import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  label: string;
  value?: React.ReactNode;
  valueAlign?: "left" | "right" | "center";
  actions?: React.ReactNode; // 👈 NOWE
};

export default function LabelValueRow({
  label,
  value,
  valueAlign = "left",
  actions,
}: Props) {
  const { t } = useAppTranslation("common");
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "140px 1fr auto", // 👈 NOWE: kolumna na actions
        gap: 1,
        py: 0.5,
        alignItems: "center",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t(label)}
      </Typography>

      <Typography
        variant="body2"
        component="span"
        sx={{
          textAlign: valueAlign,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value ?? "—"}
      </Typography>

      {/* actions są opcjonalne – gdy brak, kolumna zostaje pusta */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {actions ?? null}
      </Box>
    </Box>
  );
}